import { defineComponent as _defineComponent } from 'vue'
import NoOffers from '@/features/buybox/components/list/NoOffers.vue';
import NotifyMe from '@/features/buybox/components/list/NotifyMe.vue';
import ListUpcoming from '@/features/buybox/components/list/ListUpcoming.vue';
import type { UpcomingReleaseBuybox } from '@/features/buybox/types/types.ts';
import { useInternationalOffersStatus } from '@/features/international-offers/composables/useInternationalOffers';
import { allowedPromotionLanguages, usePromotion } from '@/helpers/composables/usePromotion';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { BuyBoxFilterOptions } from '@/stores/useUserStoreTypes';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import PromotionPlacement from '@/features/buybox/components/list/PromotionPlacement.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListUpcomingNoOffers',
  props: {
    upcomingReleases: null,
    hasUpcomingReleases: { type: Boolean },
    title: null,
    isTitleInWatchlist: { type: Boolean },
    filter: null,
    additionalContexts: null,
    seasonNumber: null
  },
  emits: ["onNotifyMe"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'onNotifyMe'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	upcomingReleases: UpcomingReleaseBuybox[];
	hasUpcomingReleases: boolean;
	title: TitleDetail;
	isTitleInWatchlist?: boolean;
	filter: BuyBoxFilterOptions;
	additionalContexts: SnowplowContext[];
	seasonNumber?: number | null;
};





const { language } = storeToRefs(useLanguageStore());
const { isActive: isInternationalOffersActive, hasInternationalOffers } = useInternationalOffersStatus({
	title: () => props.title,
});
const { promotionOffer } = usePromotion({
	title: () => props.title,
	offers: () => [],
});

const showFreeTrial = computed(
	() =>
		!!promotionOffer.value &&
		[BuyBoxFilterOptions.ALL, BuyBoxFilterOptions.FREE, BuyBoxFilterOptions.SUBSCRIPTION].includes(props.filter) &&
		// splitting language for locale specific ones like Spanish - Spain, Spanish - Latin America, etc
		allowedPromotionLanguages.includes(language.value.split('-')[0])
);

return { __sfc: true,props, emit, language, isInternationalOffersActive, hasInternationalOffers, promotionOffer, showFreeTrial, NoOffers, NotifyMe, ListUpcoming, PromotionPlacement }
}

})